import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { Equipment } from '@app/core/model/entities/equipments/equipment';
import { WorkInput } from '@app/core/model/entities/works/work';
import {
  WorkCreateModalComponent
} from '@app/features/main/views/works/works-inventory/modals/work-create-modal/work-create-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

@Component({
  templateUrl: './equipment-work-create-modal.component.html',
  standalone: false
})
export class EquipmentWorkCreateModalComponent extends WorkCreateModalComponent implements OnInit {
  private equipment = inject<{ equipment: Equipment }>(MAT_DIALOG_DATA).equipment;
  public formId: string = 'equipment_work_creation_dialog';
  private translate = inject(TranslateService);

  /**
   * Initialise missing required fields.
   */
  public ngOnInit(): void {
    super.ngOnInit();
    const defaultMissingRequiredFields = [{code: 'equipmentId', label: this.translate.instant('LABEL.EQUIPMENT')}]
      .filter(({code}) => !this.accessManager.hasFieldWriteOnCreateAccess(code, EntityTypeEnum.WORK));
    this.missingRequiredFields$ = this.missingRequiredFields$.pipe(
      map(fields => fields.concat(defaultMissingRequiredFields)),
    );
  }

  /**
   * Data from the filled form.
   * @return Work data.
   */
  public getGeneratedObject(): WorkInput {
    const input = super.getGeneratedObject();

    const properties = {
      ...input.properties,
      location: this.equipment.properties?.location,
      technicalCategoryLevel1: this.equipment.properties?.technicalCategoryLevel1,
      technicalCategoryLevel2: this.equipment.properties?.technicalCategoryLevel2,
      technicalCategoryLevel3: this.equipment.properties?.technicalCategoryLevel3,
      technicalCategoryLevel4: this.equipment.properties?.technicalCategoryLevel4,
      technicalCategoryLevel5: this.equipment.properties?.technicalCategoryLevel5,
      ...(
        this.equipment.properties?.quantity &&
        {
          costs: [
            {
              quantity: this.equipment.properties.quantity,
              unitPrice: 0,
              type: 'AMOUNT',
              ...(this.equipment.properties.unit && {unit: this.equipment.properties.unit})
            }
          ]
        }
      )
    };

    return {
      ...input,
      properties,
      assetId: this.equipment.assetId,
      spaceIds: this.equipment.spaceIds,
      equipmentIds: [this.equipment.id]
    };
  }
}
